<template>
  <fb-form-properties-manager id="signature-v1-properties-zi0rlt" :fields="fields" :formId="formId" />
</template>

<script>
export default {
  name: "SignatureV1Properties",
  props: ["formId"],
  data() {
    return {
      fields: [
        {
          type: "textInput",
          properties: {
            label: "Label"
          },
          property: "label"
        },
        {
          type: "textInput",
          properties: {
            label: "Description"
          },
          property: "description"
        },
        {
          type: "dropdown",
          properties: {
            label: "Type",
            options: [
              {
                value: "client",
                text: "Patient"
              },
              {
                value: "general",
                text: "General"
              },
              {
                value: "user",
                text: "User"
              }
            ]
          },
          property: "type"
        },
        {
          type: "checkbox",
          properties: {
            label: "Required",
            disabled: element => {
              return !(element.properties.hidden == false || element.properties.hidden == "{{!(true)}}");
            }
          },
          property: "required"
        },
        {
          type: "checkbox",
          properties: {
            label: "Editable in Patient Portal"
          },
          property: "eFormEditable"
        },
        {
          type: "checkbox",
          properties: {
            label: "Date editable"
          },
          property: "dateEditable"
        },
        {
          type: "conditionEditor",
          properties: {
            label: "Visibility condition",
            updateValueMiddleware: (value) => {return value.replace("{{(","{{!(")}
          },
          property: "hidden"   
        }
      ]
    };
  }
};
</script>

<style></style>
